import React from "react"
import { Link } from "gatsby"

import Layout from "../../../components/layout"
import { FooterAlternate1 } from "../../../components/footer"
import SEO from "../../../components/seo"

const IndexPage = () => (
    <Layout>
      <SEO title="Personal development is now critical for sales people." />

                      
<nav className="share-bar">
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/personal-development-now-critical-sales-people/&amp;title=Personal%20development%20is%20now%20critical%20for%20sales%20people.&amp;summary=Personal%20development%20is%20now%20critical%20for%20sales%20people.&amp;source=https%3A//salestribe.com/knowledge-centre/insights/personal-development-now-critical-sales-people/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-linkedin-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Personal%20development%20is%20now%20critical%20for%20sales%20people.&amp;url=https%3A//salestribe.com/knowledge-centre/insights/personal-development-now-critical-sales-people/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-twitter-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/personal-development-now-critical-sales-people/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon">
                    <svg width="26" height="26">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-googleplus-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/personal-development-now-critical-sales-people/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon">
                    <svg width="22" height="22">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-facebook-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Personal%20development%20is%20now%20critical%20for%20sales%20people.&amp;body=https%3A//salestribe.com/knowledge-centre/insights/personal-development-now-critical-sales-people/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon">
                    <svg width="20" height="20">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-email-badge"></use>
                    </svg>
                </span>
            </Link>
        </li>
    </ul>
</nav>

<article className="article">

    

<header className="header header--article article__header" id="page-header">
    <div className="header__image" >
        <div className="header__bgimage" style={{backgroundImage: "url(../../../media/images/article-ideas-brain-maze.2e16d0ba.fill-1162x655.jpg)"}}></div>
        <div className="header__video">
            <div className="embed-responsive embed-responsive-16by9"></div>
        </div>
    </div>
    <div className="header__content">
        <div className="container">
            <div className="row">
                <div className="header__inner col-md-7 col-lg-offset-1">
                    <Link to="knowledge-centre/insights/" className="header__back back-link">
                        <span className="sr-only">Back to all articles</span>
                        <i className="icon"></i>
                    </Link>
                    <div className="header__title">
                        <h3>Sales careers</h3>
                        <h1>Personal development is now critical for sales people.</h1>
                    </div>
                    <ul className="post-meta-list">
                        <li>by Graham Hawkins</li>
                        <li>12 July 2016</li>
                        <li>4 min read</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</header>


<div className="container" id="article-content">
    <div className="row">
        <div className="article__body col-sm-12 col-md-8 col-lg-offset-1 col-lg-7 wysiwyg">
            
<h3>Sales people must URGENTLY take charge of their own self-development…..or find a new career.</h3>

<div className="rich-text"><p>When a severe storm is building off the coast, and wind direction is blowing said storm directly towards you, you have a choice: 1) urgently take pre-emptive measures to guard against and minimise the damage, or 2) sit outside in your favourite chair with a couple of beers and hope that the storm changes direction and slides on by.</p><p>When it comes to B2B selling there is a big difference between being optimistic and being realistic. In previous posts, I have espoused a view (backed by almost all of the leading analysts – globally) that the sales profession is right now undergoing some massive change. To use an old military term, we sales folks are right now in the middle of some serious <strong>VUCA</strong> (Volatility, Uncertainty, Complexity &amp; Ambiguity). No-one doubts that the global business environment is more volatile now than ever before and as we move from <em>vendor-push</em> to <em>customer-pull</em> business models, there is now wide-spread acknowledgement of more massive impending change. What astonishes me most is why so many sales people are NOT reacting to this change that is now underway. Why are so many sales people still conducting themselves the same way that they did 15 years ago?....stand by for the full force of that storm.</p><p>Seriously, if you work in sales and you have deliberately put your head in the sand hoping that the storm will pass, I can assure you that you are in for a very sobering reality in the next few years. Forrester is already forecasting that 22% of B2B sales jobs will be gone by 2020 and according to Gartner, 85% of transactions will be conducted without any human involvement by 2020. If you doubt any of this then simply take a look around your own industry and look for some ‘tell-tail signs’ of turbulence. This storm is going make its mark in a huge way and the bureau of meteorology has just raised the storm severity warning from ‘severe’ to ‘extreme’.</p><p>To continue the storm/nautical analogy, sales people really have 2 options as I see it: “shape up or ship out”. That is, re-train, re-skill, re-develop or find a new career path. Sounds flippant but it’s not meant to be. The facts are that the lower quartile of all B2B sales people are going to be fired in the next 3-5 years, and the survivors of this massive culling will be required to develop skills that allow them to make the move from “generalist” sales person to “specialist” sales person with deep domain knowledge and expertise. Another rhetorical question, but how can anyone ever become a trusted adviser if they have insufficient knowledge with which to advise? How can a sale person ever execute the 'Challenger' methodology if the customer knows more than they do?</p><p>The key message here is simple: if you wish to extend your tenure as a professional B2B sales person then you had better start taking control of your own self development. This will mean throwing out much of what you have previously learned, and developing new skills and knowledge that will help to keep you current with the new VUCA world that is upon us.<br/></p><p><strong>1) Read: </strong>There are a lot of great books being published right now that shine a light on this VUCA world that we live in. Start reading.</p><p><strong>2) Engage with thought leaders on LinkedIn:</strong> There are lots of sales based groups where thought leadership is proliferating, and these groups are made up of vast numbers of individuals that can offer guidance, coaching and mentoring - approach them and ask for guidance.</p><p><strong>3) Engage a coach or mentor: </strong>As above, speak with someone that has already been through some change cycles. Open your mind to the wisdom of others. </p><p><strong>4) Career change:</strong> If you are fortunate enough to be working with an organisation that actively drives programs around employee development then maybe it is time for a lateral career move to broaden your skill set and knowledge. </p><p><strong>5)  Enrol in a course: </strong>Above and beyond the myriad of post-grad study options, there are now some amazing short courses available spanning an array of topics that are perfect for augmenting a sales persons skills. A few years ago I chose to undertake an Executive MBA and it absolutely helped change the course of my career (see article: <a href="http://bit.ly/24HNjtZ">http://bit.ly/24HNjtZ</a>). For me personally, the MBA program allowed me to “zoom out” (to step back from the blinkered grind of daily sales activity) and to actually research some of the driving forces of change that are now impacting the world of B2B sales. Importantly, the MBA also dramatically expanded my network and this can never be understated.....especially important now as VUCA takes hold. RMIT, like so many others, runs a great MBA program and it’s exactly this type of self-development that will help insulate sales people from the aforementioned storm that his coming at us all.</p></div>
<aside className="pull-quote">
    <blockquote>
        <p>“Life isn’t about finding yourself. Life is about creating yourself.” — George Bernard Shaw</p>
    </blockquote>
</aside>

<div className="rich-text"><p>Yes, career changes are scary, and yes, education (especially an MBA) and books cost money. But what you have to ask yourself now is whether or not you are sufficiently prepared and protected against the storm that is coming. As Charles Darwin said, it’s not the strongest that survive but the most adaptable to change. It's no longer a question of whether you can afford any investment in your own personal development.....on the contrary, the question is now <i>can you afford not to</i>? </p><p>Time to adapt, learn and grow.  </p></div>


        </div>
            
        <aside className="article__sidebar col-sm-12 col-md-4 col-lg-offset-1 col-lg-3">
            <div className="article__sidebar-wrap" id="article-sidebar">
                <div className="card card--profile">
                        
<div className="card__header">
    <div className="card__image">
        <img alt="Mentor Thumb Graham Hawkins" className="img-responsive" height="165" src="../../../media/images/Mentor-Thumb-Graham-Hawkins.2e16d0ba.fill-165x165.jpg" width="165"/>
    </div>
    <div className="card__title">
        <h4>Graham Hawkins</h4>
        <p>SalesTribe Mentor</p>
        <Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-md hidden-lg">View full profile</Link>
    </div>
</div>
<div className="rich-text"><p>With more than twenty-eight years of business experience in
executive B2B sales and sales leadership roles, Graham is a highly experienced
and versatile business executive with proven strengths in strategic business
development, go-to-market planning and sales and marketing.</p><p><br/></p><p><br/></p></div>
<Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-xs hidden-sm">View full profile</Link>

                </div>
                <nav className="social-nav">
    <h4>Share</h4>
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/personal-development-now-critical-sales-people/&amp;title=Personal%20development%20is%20now%20critical%20for%20sales%20people.&amp;summary=Personal%20development%20is%20now%20critical%20for%20sales%20people.&amp;source=https%3A//salestribe.com/knowledge-centre/insights/personal-development-now-critical-sales-people/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon icon-linkedin"></span>
                
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Personal%20development%20is%20now%20critical%20for%20sales%20people.&amp;url=https%3A//salestribe.com/knowledge-centre/insights/personal-development-now-critical-sales-people/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon icon-twitter"></span>
                
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/personal-development-now-critical-sales-people/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon icon-google-plus"></span>
                
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/personal-development-now-critical-sales-people/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon icon-facebook-f"></span>
                
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Personal%20development%20is%20now%20critical%20for%20sales%20people.&amp;body=https%3A//salestribe.com/knowledge-centre/insights/personal-development-now-critical-sales-people/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon icon-envelope"></span>
                
            </Link>
        </li>
    </ul>
</nav>

            </div>
        </aside>
            
    </div>
</div>
</article>

<div className="block block--grey related-items">
    <div className="related-items__wrap">
        <div className="container">
            <div className="row" data-tablet-slick>
                
        <article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/7-laws-sales-success" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-ideas-announcement.jpg" className="card__image" height="404" src="../../../media/images/article-ideas-announcement_6oOJESq.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">5 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">Sales careers</p>
                        <h3 className="card__title"><strong>The 7 Laws of Sales Success</strong></h3>
                    </header>
                    <p>There are certain &quot;Laws&quot; of the universe which successful people often leverage, and today&#39;s&#39; sales people must learn to embrace some of these important laws to ensure future sales success.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-outreach-destroying-your-career" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-challenge-yell.jpg" className="card__image" height="404" src="../../../media/images/article-challenge-yell_YbkW7pV.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">5 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">Sales careers</p>
                        <h3 className="card__title"><strong>Is sales Outreach destroying your Career?</strong></h3>
                    </header>
                    <p>If you are still performing 20th century outreach tactics like &quot;cold calling&quot; then you are not just destroying your own career, but you are also destroying your employers brand and therefore their business.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/extrovert-introvert-rethinking-sales-priorities" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-challenge-juggle.jpg" className="card__image" height="404" src="../../../media/images/article-challenge-juggle_PUKUKDN.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">4 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">Sales careers</p>
                        <h3 className="card__title"><strong>From extrovert to introvert: Rethinking sales priorities</strong></h3>
                    </header>
                    <p>What is the profile of a modern sales person?

This article was written by Graham Hawkins and it first appeared on the Salesforce Blog in July 2018:</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article>

            </div>
            <div className="load-more">
                <Link to="knowledge-centre/insights/" className="btn btn-link">Browse more insights</Link>
            </div>
        </div>
    </div>
</div>

      
      <FooterAlternate1 />

    </Layout>
)

export default IndexPage 